const PARTNER_URL = 'https://browser.yandex.ru/download?partner_id=831050&banerid=1313986980&erid=5jtCeReNx12oajxRXc9ST8s';
export default function YandexBrowserAd() {
  // Маркировка и полный партнёрский URL находятся рядом с самим объявлением,
  // чтобы рекламная ссылка не потеряла обязательный erid при изменениях окружающей страницы.
  return m('section.dc-ad.dc-ad--yandex', {
    'aria-label': 'Реклама Яндекс Браузера'
  }, [m('div.dc-ad__mark', 'Реклама · erid: 5jtCeReNx12oajxRXc9ST8s'), m('div.dc-ad__brand', [m('span.dc-ad__logo', 'Я'), m('strong', 'Яндекс Браузер')]), m('h3', 'Быстрый и безопасный браузер'), m('ul', [m('li', 'Защита от опасных сайтов'), m('li', 'Перевод страниц и видео'), m('li', 'Синхронизация на устройствах')]), m('a.dc-ad__button', {
    href: PARTNER_URL,
    target: '_blank',
    rel: 'sponsored nofollow noopener'
  }, 'Скачать бесплатно')]);
}
flarum.reg.add('devconnect-portal', 'forum/components/YandexBrowserAd', YandexBrowserAd);